import React from 'react';
import PropTypes from 'prop-types';
import LineItemII from '../LineItemII';
import Loading from '../Loading';
import Panel from 'wonderbly-components/lib/Panel';
import { localiseUrl } from 'src/common/utils/format-localised-url';

import './CartItemsII.scss';

const CartItemsII = (props) => (
  <section className="cart-items cart-items-ii">
    <div className="container-guttered cart-items-container">
      <div className="cart-items-title-wrapper">
        <h1 className="text-kilo">{props.title}</h1>
        <a className="text-base" href={localiseUrl(props.model.countryModel, props.basketCtaLink)}>{props.basketCtaText}</a>
      </div>
      <div className="cart-items-inner">
        {props.items.map(item => (
          <Panel className="line-item-ii" key={item.id}>
            <LineItemII
              item={item}
              handleRemove={props.cart.remove}
              editItemCta={props.editItemCta}
              editGiftwrapCta={props.editGiftwrapCta}
              addGiftwrapCta={props.addGiftwrapCta}
              editExtrasCta={props.editExtrasCta}
              addExtrasCta={props.addExtrasCta}
              savingsPriceLabel={props.savingsPriceLabel}
              isMobile={props.media.mobile}
              isEditable
              isRemovable
            />
          </Panel>
        ))}
        {props.isCartPending && <Loading dark />}
      </div>
    </div>
  </section>
);

CartItemsII.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  cart: PropTypes.object.isRequired,
  isCartPending: PropTypes.bool.isRequired,
  editItemCta: PropTypes.string.isRequired,
  editGiftwrapCta: PropTypes.string.isRequired,
  addGiftwrapCta: PropTypes.string.isRequired,
  editExtrasCta: PropTypes.string,
  addExtrasCta: PropTypes.string,
  savingsPriceLabel: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  model: PropTypes.shape({
    countryModel: PropTypes.object
  }),
  basketCtaLink: PropTypes.string,
  basketCtaText: PropTypes.string
};

export default CartItemsII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItemsII/CartItemsII.js